import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Heading from 'components/shared/heading';
import styles from './styles.module.scss';
import MediaWithTextListItem from './Item';

const MediaWithTextList = ({
  title = null,
  titleTag = 'h2',
  description = null,
  items = [],
  theme = null,
}) => (
  <section
    className={cn(styles.mediaWithTextList, {
      [styles.themeLight]: theme === 'light',
      [styles.themeDark]: theme === 'dark',
    })}
  >
    <div className="container">
      <div className={styles.inner}>
        {title && (
          <Heading className={styles.title} tag={titleTag} size="xl">
            {title}
          </Heading>
        )}
        {description && (
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        )}
        <div className={styles.items}>
          {items.map((item, index) => (
            <MediaWithTextListItem
              key={index}
              title={item.title}
              description={item.description}
              image={item.image}
              buttonLink={item.buttonLink}
              buttonLabel={item.buttonLabel}
              secondaryButtonLink={item.secondaryButtonLink}
              secondaryButtonLabel={item.secondaryButtonLabel}
              reverse={index % 2 === 1}
              isDarkTheme={theme === 'dark'}
            />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default MediaWithTextList;

MediaWithTextList.propTypes = {
  title: PropTypes.string,
  titleTag: PropTypes.oneOf(['h1', 'h2', 'h3']),
  description: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.shape({
        id: PropTypes.number,
      }),
      buttonLink: PropTypes.string,
      buttonLabel: PropTypes.string,
      secondaryButtonLink: PropTypes.string,
      secondaryButtonLabel: PropTypes.string,
    })
  ).isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
};
